import * as React from 'react';
import { AttributesTable } from 'shared';
import { DateField, Edit, FieldProps, SimpleForm, TextField, useRecordContext } from 'react-admin';
import { FC } from 'react';

// const DataTextFields = ({ record, source }) => record[source].keys.map((field) => <div key={field}>{`${field}`}</div>);
// // <span style={{ color: 'purple' }}>{record[source]}</span>

// interface CustomFieldProps {
//   record?: { [key: string]: any };
//   source?: string;
// }

// const DataTextFields = ({ record, source }) => <span style={{ color: 'purple' }}>{record[source]}</span>;

export const DataTextFields: FC<FieldProps> = (props) => {
  const { source } = props;
  const record = useRecordContext()

  if (!record) return <div>No data</div>;

  return <AttributesTable data={record[source]} />;
};

export const EntryEdit = () => (
  <Edit>
    <SimpleForm>
      <DataTextFields source="data" />

      <TextField source="id" />
      <DateField label="Submitted" source="createdAt" />

      {/* <ReferenceField label="Form" source="form.id" reference="Form">
        <TextField source="name" />
      </ReferenceField> */}
      {/* {Object.keys(record[source]).map(function (key, idx) {
        return <TextField key={idx} record={record[source]} source={key} {...rest} label={key} />;
      })} */}
    </SimpleForm>
  </Edit>
);
